<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item>客户企业管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div @click="handleDetail('')">
            <p class="flex-rowl"><i class="iconfont icon-xinzeng"></i> 新增</p>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="getCustomerBodyList()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="getCustomerBodyList">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示客户企业列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="(item, index) in dataList" :key="index">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl" @click="handleDetail(item.id)">
                  <div class="block">
                    <p>
                      客户企业名称：
                      <span>{{
                        item.bodyname ? item.bodyname : item.bodyname
                      }}</span>
                    </p>
                    <p>
                      所属企业名称：
                      <span>{{ item.qyname }}</span>
                    </p>
                    <!-- <p class="customer_wrap" v-if="item.info_tag_idstr">
                      <span class="customer_item">{{
                        item.info_tag_idstr
                      }}</span>
                    </p> -->
                  </div>
                  <div class="block address_wrap">
                    <p>所在地区：</p>
                    <p>
                      <span>{{ item.bodyprovincestr }}</span>
                      <span>{{ item.bodycitystr }}</span>
                      <span>{{ item.bodyareastr }}</span>
                      <span>{{ item.bodyaddr }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>行业标签：</p>
                    <p>
                      <span v-if="item.label1str">{{ item.label1str }}</span>
                      <span v-if="item.label2str">、{{ item.label2str }}</span>
                      <span v-if="item.label3str">、{{ item.label3str }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>是否启用：</p>
                    <p class="red">
                      <span>{{ item.isuse == 1 ? "启用" : "停用" }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty description="暂无数据" v-else></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <!-- <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div> -->
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringadd, getCustomerBodyList } from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "customerList",
  data() {
    return {
      type: 1,
      dataList: [],
      loading: false,
      params: {
        qyguid: "",
        keyword: "",
      },
      listTotal: 0,

      // 客户标签
      customerOptin: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { USERINFO } = this.$store.state;
    this.params.qyguid = USERINFO.qy.qyguid;
    this.getCustomerBodyList();
  },
  methods: {
    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getCustomerBodyList();
    },

    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.params.orderlink = "";
      this.params.orderamount = "";
      this.params.info_tag_id = "";
      this.getCustomerBodyList();
    },

    // 获取数据
    getCustomerBodyList() {
      this.loading = true;
      getCustomerBodyList(this.params).then((res) => {
        res.list.sort((a, b) => {
          const dateA = new Date(a.addtime);
          const dateB = new Date(b.addtime);
          return dateB - dateA; // 按照时间从大到小排序
        });
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },

    handleDetail(id) {
      if (id) {
        this.encryptstringadd("customerDetail", { id });
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
      } else {
        this.encryptstringadd("customerDetail", "");
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .operation_wrap {
    .screen_wrap {
      font-size: 14px;
      .sort_wrap {
        border: 1px solid #d8d8d8;
        border-radius: 20px;
        height: 35px;
        padding: 0 10px;
        margin-right: 10px;
      }
      .select_wrap {
        margin-right: 10px;
      }
      .icon-24gl-swapHorizontal {
        transform: rotate(90deg);
      }
    }
  }
  .list_wrap {
    .item_main_wrap {
      .address_wrap {
        width: 28%;
      }
      .customer_wrap {
        span {
          height: 40px;
          border: 1px solid #d2d2d2;
          font-size: 12px;
          padding: 0 10px;
          margin-right: 5px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .intro_box {
        cursor: pointer;
      }
    }
    .red {
      color: #ff0036;
    }
  }
}
</style>